import validate from "/usr/src/app/content/n3-spas-5e491b7b-6288-4554-8585-22f3de537a90/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-5e491b7b-6288-4554-8585-22f3de537a90/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}